<!--
   This is where Vue Tour logic is kept for the tutorial.
   Component loaded in App.vue
   Start Tutorial called in /components/HelpMenu.vue

   Steps: defines the steps tour will go through. uses selectors ['.tut1' - '.tut5', '#download']
   Callbacks: (not in use) Can be used for actions before and after each step
   Options: Overwrites naming of the buttons
-->
<template>
  <div id="tutorial">
    <v-tour name="homeTour" :steps="steps" :callbacks="tourCallbacks" :options="tourOptions">
      <template slot-scope="tour">
        <TutorialCard :tour="tour" @skip="skipTutorial" />
      </template>
    </v-tour>
    <v-overlay :z-index="100" :value="overlay"></v-overlay>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import { tutorialData } from '@/data/constants';
import {
  ACTION_TUTORIAL_FINISHED,
  ACTION_TUTORIAL_QUIT,
  CATEGORY_TUTORIAL,
} from '@/data/constants/constantsGoogleAnalyticsEvents';
import TutorialCard from '@/components/tutorial/TutorialCard';
import { MENU_TOOLTIP_ID } from '@/data/constants/constantsTooltip';

export default {
  components: { TutorialCard },
  data() {
    return {
      overlay: false,
      tourOptions: {
        labels: {
          buttonSkip: 'Cancel',
          buttonPrevious: 'Back',
          buttonNext: 'Next',
          buttonStop: 'Next',
        },
      },
    };
  },

  computed: {
    ...mapState({
      step: (state) => state.draft.step,
      claims: (state) => state.draft.claims,
      showWorkspace: (state) => state.draft.showWorkspace,
    }),

    tourCallbacks() {
      return {
        onStart: () => {
          this.startViewingTutorial();
          this.toggleOverlay(true);
        },

        onSkip: () => {
          this.stopViewingTutorial();
          this.toggleOverlay(false);
          this.toggleTooltip(MENU_TOOLTIP_ID);
        },

        onFinish: () => {
          this.$gtag.event(ACTION_TUTORIAL_FINISHED, { event_category: CATEGORY_TUTORIAL });
          this.toggleOverlay(false);
          this.hideTutorialCloseButtons();
        },
      };
    },

    /**
     * @returns {Array}
     */
    steps() {
      if (!this.showWorkspace) return tutorialData.newDocumentSteps;
      if (this.showWorkspace) {
        if (this.step === 1) {
          if (this.claims.length > 0) return tutorialData.filledClaimSteps;
          return tutorialData.claimSteps;
        }
        if (this.step === 2) {
          return tutorialData.generateSteps;
        }
      }
      return [];
    },
  },
  methods: {
    ...mapMutations({
      toggleTooltip: 'tooltip/toggleTooltip',
      setShowWorkspace: 'draft/setShowWorkspace',
      hideTutorialCloseButtons: 'draft/hideTutorialCloseButtons',
      startViewingTutorial: 'draft/startViewingTutorial',
      stopViewingTutorial: 'draft/stopViewingTutorial',
    }),

    skipTutorial({ tour }) {
      const event_label = `on step ${tour.currentStep + 1} of ${
        this.showWorkspace
          ? `generate view on step ${this.step} of generate process`
          : 'dashboard view'
      }`;
      this.$gtag.event(ACTION_TUTORIAL_QUIT, { event_category: CATEGORY_TUTORIAL, event_label });
      tour.skip();
    },

    /**
     * Shows/hides overlay. Can optionally provide a boolean message to manually set the overlay
     * @param {Boolean} [val] - If true shows overlay, if false hides overlay.
     */
    toggleOverlay(val = !this.overlay) {
      this.overlay = val;
    },
  },
};
</script>

<style lang="scss" scoped></style>
